<div class="alerts-card">
<loading [isLoading]="isLoading"></loading>
    <div class="alerts-card-top">

        <div class="top-left">
            <h2>Total de Alarmas en el Mes</h2>
            
        </div>

        <div class="top-right">
           <mat-icon class="icon">error</mat-icon>
        </div>

    </div>

    <div class="alerts-card-bottom">
        
        <div class="chart-container">
                <canvas class="chart" id="alertChart" *ngIf="pieChartData?.datasets[0]?.data?.length"
                        baseChart
                        [data]="pieChartData"
                        [type]="'pie'"
                        [labels]="pieChartLabels"
                        [options]="options">
                </canvas>
        </div>

        <div class="no-result-item" *ngIf="!isLoading && (!pieChartData?.datasets[0]?.data?.length || pieChartData?.datasets[0]?.data?.length === 0)">
            <h1>No hay datos</h1>
        </div>
        
    </div>
</div>